"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BSNeo3Constants = void 0;
const mainnet_json_1 = __importDefault(require("../assets/tokens/mainnet.json"));
class BSNeo3Constants {
}
exports.BSNeo3Constants = BSNeo3Constants;
_a = BSNeo3Constants;
BSNeo3Constants.EXTRA_TOKENS_BY_NETWORK_ID = {
    mainnet: mainnet_json_1.default,
};
BSNeo3Constants.RPC_LIST_BY_NETWORK_ID = {
    mainnet: [
        'https://mainnet1.neo.coz.io:443',
        'https://mainnet4.neo.coz.io:443',
        'http://seed1.neo.org:10332',
        'http://seed2.neo.org:10332',
        'https://mainnet2.neo.coz.io:443',
        'https://mainnet5.neo.coz.io:443',
        'https://mainnet3.neo.coz.io:443',
        'https://rpc10.n3.nspcc.ru:10331',
        'https://neo1-nodes.ghostmarket.io:443',
    ],
    testnet: [
        'https://testnet1.neo.coz.io:443',
        'https://testnet2.neo.coz.io:443',
        'https://rpc.t5.n3.nspcc.ru:20331',
        'http://seed1t5.neo.org:20332',
        'http://seed2t5.neo.org:20332',
        'http://seed3t5.neo.org:20332',
        'http://seed4t5.neo.org:20332',
        'http://seed5t5.neo.org:20332',
    ],
};
BSNeo3Constants.MAINNET_NETWORK_IDS = ['mainnet'];
BSNeo3Constants.TESTNET_NETWORK_IDS = ['testnet'];
BSNeo3Constants.ALL_NETWORK_IDS = [..._a.MAINNET_NETWORK_IDS, ..._a.TESTNET_NETWORK_IDS];
BSNeo3Constants.MAINNET_NETWORKS = [
    {
        id: 'mainnet',
        name: 'Mainnet',
        url: _a.RPC_LIST_BY_NETWORK_ID['mainnet'][0],
    },
];
BSNeo3Constants.TESTNET_NETWORKS = [
    {
        id: 'testnet',
        name: 'Testnet',
        url: _a.RPC_LIST_BY_NETWORK_ID['testnet'][0],
    },
];
BSNeo3Constants.ALL_NETWORKS = [..._a.MAINNET_NETWORKS, ..._a.TESTNET_NETWORKS];
BSNeo3Constants.DEFAULT_NETWORK = _a.MAINNET_NETWORKS[0];
BSNeo3Constants.NEO_NS_HASH = '0x50ac1c37690cc2cfc594472833cf57505d5f46de';
BSNeo3Constants.DEFAULT_BIP44_DERIVATION_PATH = "m/44'/888'/0'/0/?";
